<template>
	<div id="dashboard-patient" class="pb-4">
		<template v-if="!user.hasFilledPersonalInformation">
			<Suspense>
				<template #default>
					<patient-form></patient-form>
				</template>
				<template #fallback>
					<inline-loading-indicator></inline-loading-indicator>
				</template>
			</Suspense>
		</template>
		<template v-else>
			<likert-modal ref="likertSurvey"></likert-modal>
			<div class="px-4 my-4 container">
				<measurement-schedule-list
					:schedules="user.lastMeasurementSchedule"
				></measurement-schedule-list>
			</div>
			<div class="container block">
				<p class="title is-5 is-txt-accent-dark">Acciones</p>
			</div>
			<div class="menu-container nrg-flex-group px-4 container">
				<div
					id="action-how-to-use"
					class="menu-action nrg-flex-item is-size-5"
					@click="onActionClick"
				>
					<div class="py-4">
						<book-open-icon size="60px"></book-open-icon>
					</div>
					<span class="div-text"> Manual de uso </span>
				</div>
				<div
					id="action-view-measures"
					class="menu-action nrg-flex-item is-size-5"
					@click="onActionClick"
				>
					<div class="py-4"><therm-icon size="60px"></therm-icon></div>
					Tus medidas
				</div>

				<div
					id="action-faqs"
					class="menu-action nrg-flex-item is-size-5"
					@click="onActionClick"
				>
					<div class="py-4">
						<help-circle-icon size="60px"></help-circle-icon>
					</div>
					Preguntas Frecuentes
				</div>
				<div
					id="action-view-diary"
					class="menu-action nrg-flex-item is-size-5"
					@click="onActionClick"
				>
					<div class="py-4"><book-icon size="60px"></book-icon></div>
					Tu diario
				</div>

				<div
					id="action-do-likert"
					class="menu-action nrg-flex-item half-height nrg-span-2x is-size-5"
					@click="onActionClick"
				>
					<div class="py-1"><smile-icon size="60px"></smile-icon></div>
					¿Cómo te sientes hoy?
				</div>
			</div>
		</template>
	</div>
</template>

<script lang="ts">
	import { defineComponent, ref } from "vue";
	import LikertModal from "@/components/LikertSurvey.vue";
	import PatientForm from "@/components/PatientForm.vue";
	import MeasurementScheduleList from "@/components/MeasurementScheduleList.vue";
	import ThermIcon from "@/assets/ThermIcon.vue";
	import SmileIcon from "@/assets/SmileIcon.vue";
	import HelpCircleIcon from "@/assets/HelpCircleIcon.vue";
	import BookIcon from "@/assets/BookIcon.vue";
	import BookOpenIcon from "@/assets/BookOpenIcon.vue";
	// import MenuCard from "@/components/MenuCard.vue";
	import { useRouter } from "vue-router";
	import useUser from "@/store/UserState";

	export default defineComponent({
		name: "dashboard-patient",
		components: {
			LikertModal,
			PatientForm,
			ThermIcon,
			HelpCircleIcon,
			SmileIcon,
			BookIcon,
			BookOpenIcon,
			MeasurementScheduleList,
			// MenuCard,
		},
		setup() {
			const router = useRouter();
			const { user } = useUser();

			const likertSurvey = ref(null);

			function onActionClick(ev: Event): void {
				console.log("actionClick", ev);
				switch ((ev.currentTarget as HTMLElement).id) {
					case "action-view-measures":
						router.push({
							name: "measurements",
						});
						break;
					case "action-view-diary":
						router.push({
							name: "diaries",
						});
						break;
					case "action-faqs":
						router.push({
							name: "faq",
						});
						break;
					case "action-how-to-use":
						router.push({
							name: "manual",
						});
						break;
					case "action-do-likert":
						(likertSurvey.value! as typeof LikertModal).open();
						break;
				}
			}
			return {
				user,
				likertSurvey,
				onActionClick,
			};
		},
	});
</script>

<style lang="stylus" scoped>
	@import '../styles/layout.styl';
	@import '../styles/fonts.styl';
	@import '../styles/elements.styl';

	div.nrg-flex-item {
		min-height: 150px;
	}

	div.nrg-flex-item.half-height {
		min-height: 120px;
	}

	.menu-action {
		@extend .cell-shiny-primary;
		// background-image: url('https://source.unsplash.com/200x200/?medicine');
		// background-blend-mode: multiply;
		// background-size: cover;
	}
	.menu-action:nth-child(1) {
		// background-color: primaryColor;
		background: linear-gradient(60deg, #6b95ff, #20CDDE);
	}

	.menu-action:nth-child(2) {
		// background-color: #428876;
		background: linear-gradient(60deg, #20CDDE, #90F8B5);
	}

	.menu-action:nth-child(3) {
		// background-color: #A1529F;
		background: linear-gradient(60deg, #20CDDE, #00ADE7);
	}

	.menu-action:nth-child(4) {
		// background-color: #7F78CC;
		background: linear-gradient(60deg, #20CDDE, #00B992);
	}

	.menu-action:nth-child(5) {
		background: linear-gradient(60deg, #00B992, #90F8B5);
		// background-color: #005565;
	}

	.nrg-flex-group-v2 {
		@extend .nrg-flex-group;

		@media screen and (max-width: 600px) {
			display: flex;
			height: 400px;
			align-items: center;
			width: 100%;
			overflow-x: auto;
		}

		.menu-action, .nrg-flex-item, .half-height {
			@media screen and (max-width: 600px) {
				min-width: 250px;
				min-height: 250px !important;
			}
		}
	}

	.image-portrait svg {
		height: 50px;
	}

</style>